import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  chatActual = new Subject();
  borrarchat = new Subject();

  constructor(private api: CloudFunctionsApiService) {}

  getMessages(chatid, uid) {
    return this.api.snapshotList(`/chats/${chatid}/messages?visibleTo=${encodeURIComponent(uid)}`);
  }

  getLastMessage(chatid, uid) {
    return this.api
      .snapshotList(`/chats/${chatid}/messages?visibleTo=${encodeURIComponent(uid)}&limit=1&order=desc`);
  }

  getChats(tuid) {
    return this.api.valueList(`/chats/user/${tuid}`);
  }

  get2Chats(tuid) {
    return this.api.valueList(`/chats/user/${tuid}?limit=2`);
  }

  createChat(chatData: { user_ids: string[]; type: string; [key: string]: any }) {
    return this.api.post('/chats', chatData).toPromise();
  }

  createdMessage(message, id) {
    return this.api.patch(`/chats/${id}`, message).toPromise();
  }

  setchatmembers(id, members) {
    return this.api.patch(`/chats/${id}`, members).toPromise();
  }

  async sendmessage(id, message, members) {
    await this.setchatmembers(id, members);
    return this.api.post(`/chats/${id}/messages`, message).toPromise();
  }

  sendmessageclase(id, message) {
    return this.api.post(`/chats/${id}/messages`, message).toPromise();
  }

  getClaseMessages(chatid) {
    return this.api.snapshotList(`/chats/${chatid}/messages`);
  }

  countmemberschat(id) {
    return this.api.getDocument(`/chats/${id}`).toPromise();
  }

  updatemessage(chatid, mesid, update) {
    return this.api.patch(`/chats/${chatid}/messages/${mesid}`, update).toPromise();
  }

  deleteconversation(id, members, receiveruid) {
    return this.api.patch(`/chats/${id}`, members).toPromise();
  }

  getIdsContainingSubstring(substring: string): Observable<string[]> {
    return this.api.valueList('/chats').pipe(
      map((chats) => chats.map((chat) => chat.id || '').filter((id) => id.includes(substring)))
    );
  }

  setChatActual(chatid) {
    this.chatActual.next(chatid);
  }

  getChatActual() {
    return this.chatActual;
  }

  borrarelChat(data) {
    this.borrarchat.next(data);
  }

  getBorrarElChat() {
    return this.borrarchat;
  }
}
